import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { SegmentedControl } from 'cng-common/components/segmentedControl'
import { Translation } from 'cng-common/features/translations'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../../../configs/translations'
import { setCockpitFilterMdfStatus } from '../../../../../../model'
import { selectCockpitFilterMdfStatus } from '../../../../../../model/selectors'
import { TMdfStatus } from '../../../../../../model/types'
import { CockpitSegmentedControlAccent } from '../../../../../components/cockpitSegmentedControlAccent'

import styles from './CockpitMdfStatusFilter.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.mdfStatus

const MDF_STATUS_OPTIONS: TMdfStatus[] = ['All', 'MDF', 'Non-MDF']

export const CockpitMdfStatusFilter = () => {
  const dispatch = useAppDispatch()
  const selectedStatus = useSelector(selectCockpitFilterMdfStatus)

  const handleSelect = useCallback(
    (status: TMdfStatus) => {
      dispatch(setCockpitFilterMdfStatus(status))
    },
    [dispatch]
  )

  return (
    <div className={styles.root}>
      <Translation text={KEYS.label} span />
      <CockpitSegmentedControlAccent stretched>
        <SegmentedControl
          useItemKeys
          selectedItem={selectedStatus}
          onItemSelect={handleSelect}
          size="small"
          variant="veneer"
          isStreatched
        >
          {MDF_STATUS_OPTIONS.map((status) => (
            <SegmentedControl.Item key={status} itemKey={status}>
              <span>{status}</span>
            </SegmentedControl.Item>
          ))}
        </SegmentedControl>
      </CockpitSegmentedControlAccent>
    </div>
  )
}
